import {AfterViewChecked, ChangeDetectorRef, Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {ClientService} from 'src/app/services/client.service';
import {AccountService} from 'src/app/services/account.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {saveAs} from 'file-saver';
import {Location} from '@angular/common';
import {ReportService} from '../../services/report.service';
import {QuestionComponent} from './question/question.component';
import {ComponentCanDeactivate} from '../../services/security-services/guards/unsaved-changes-guard.service';
import {Observable} from 'rxjs';
import {NotificationService} from '../../services/notification.service';
import {CurrentUserService} from '../../services/current-user.service';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDownloadFinalDialogComponent} from './confirm-download-final-dialog/confirm-download-final-dialog.component';
import {NgForm} from '@angular/forms';
import {QuestionDTO} from '../../model/questionDTO';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {ReportPreviewDialogComponent} from './report-preview-dialog/report-preview-dialog.component';
import {ShouldPreviewService} from '../../services/should-preview-service';
import {ReportMetaDataDTO} from '../../model/reportMetaDataDTO';
import {UserService} from '../../services/user.service';
import {ReportTypeCode} from '../../model/reportTypeCode';

enum States { PENDING, SAVING, SAVED}
@Component({
  styleUrls: ['./report.component.scss'],
  templateUrl: './report.component.html'
})
export class ReportComponent implements OnInit, ComponentCanDeactivate, AfterViewChecked {

  constructor(private accountService: AccountService,
              private shouldPreviewService: ShouldPreviewService,
              private route: ActivatedRoute,
              private clientService: ClientService,
              private changeRef: ChangeDetectorRef,
              public service: ReportService,
              private currentUserService: CurrentUserService,
              private userService: UserService,
              public loc: Location,
              private dialog: MatDialog,
              private notificationService: NotificationService,
              private router: Router,
              private loaderService: NgxUiLoaderService,
              public translate: TranslateService) {
    translate.use('nl');
  }

  private requiresPayment = {
    header: 'voldoe het abonnementsgeld om verder te gaan met het aanmaken van rapportages',
    ok: 'naar betaalpagina',
  };

  @ViewChild('form') form: NgForm;
  private stickyButtonsThreshold = 379;
  stickyButtons;
  clientId: number;
  reportTypeCode: ReportTypeCode;
  year?;
  showErrors = false;

  questions: QuestionDTO[] = [];
  answers = [];
  model: any = [];
  currentCategory: string;
  private subscriptions = new Map();
  state: States = States.SAVED;
  reportMetaData: ReportMetaDataDTO;

  ngOnInit() {
    this.route.params.subscribe(({ clientId, year, reportType }) => {
      this.clientId = clientId;
      this.year = year;
      this.reportTypeCode = ReportService.getReportTypeFromUrl(reportType);
      this.getQuestions();
      this.service.getReportMetaData(this.reportTypeCode, this.clientId, this.year)
        .subscribe(metaData => this.reportMetaData = metaData);
      if (this.shouldPreviewService.get()) {
        this.showPreviewModal();
      }
    });
  }

  ngAfterViewChecked(): void { this.changeRef.detectChanges(); }

  private getQuestions() {
    this.service.getQuestions(this.reportTypeCode).subscribe(data => {
      this.questions = data;
      this.getAnswers();
    });
  }

  private getAnswers() {
    this.service.getAnswers(this.reportTypeCode, this.clientId, this.year)
      .subscribe(data => this.mapAnswersToModel(data));
  }

  calculateTotals() {
    const calculateTotal = questions => {
      let total = 0;
      questions.forEach(question => {
        if (this.model[question]?.value != null && !isNaN(this.model[question].value)) {
          total = total + QuestionComponent.calculateMonthly(parseFloat(this.model[question].value), this.model[question].period);
        }
      });
      return QuestionComponent.numberToEuro(total);
    };
    if (this.reportTypeCode === 'BB') {
      // tslint:disable-next-line:max-line-length
      const expenses = ['c3202a293d2144ecbd30c03f18d7ef31', 'ed9a82127d565416c9c4e5a8145f0b33', '83ec4c7c363745c7a3be6cad053beec3', '63c6f82480ea43508f1fa049eacfd9cd', 'ccb93e87d6b3422da8e706be18e5be1f', '8332ada0df824423995b094ff8688f7c', '83cfe9dafbf54dc4af16720e62d1d890', 'd524560f993b423ca0d73f622d8be613', 'ce1f003eb4434994ab696b7b08c63c70', 'f55b1b77f2fd4cc59dd0066bc23c7496', '5d98b8117f8b48daae5c42117962b25a', '52c333b1d40f4356ad41bc8ea75b1d15', '899d120a34f84651a8a594587e3b2c98', '672a3f7dfc7b4cd5b45132b2cf328728', 'af1080c030b240c89a19efb2f935c16c', 'e790ea2b7b1144a99ce5f0f59eb34f39', 'addf3d66437d4be7b4019928035330cb', 'a7c7338323b74a79948d8aba46de234d', '7c815d82bac246f299ca28203313be07', '1982e1ed6f894e81a1f876fc72994f31', 'a06e5b4fac91419b88612df3ea451cfa', '983c579cb7224e8087e4b6999b9a5e64', 'be8a2d3e49ac4f53b89c284776328a26', '25c69e1e97e64ac49d5eadaa65aa46d5', '077e928c61ad4a68a08308c5847278f7', '831649f0e62348b38f2ee729604afaaa', 'ebb6f6e033344324921e2c4b773f33f2', 'f5b31f0ebaa347d7947d7e0e51ec520b', 'd9053a90649b47e09af5f606d1928d6c', 'dbc0b74df317414abe2c32ddfb2b38e3', 'e3aa506a4238441984cacfc0028cff22', 'f525374d46e44617bb15e8605076291a', '1c41ed56781e475d880943d5cc22cca7', 'c9d6d4f37bb241728f98c8232c4856e2', '2a949ed586994f0ab89fe9b5eb253288', 'a75c5aa4559c45318e8571da25e067aa', '9db710367e5d447580ea1eb1d31d1d59', '83a6b35466054917860e398bbe95d178', 'be74c2f54ceb46ea9f99fc7f3aabbc8c', '0bf02558815b4eebbf9b7f2e84086416', '7028a1440baf4390ba9dc525b97f37b6', '41875bd7156549a69701cba0cd64efdf', 'c0d61bc7508b493088a0c235c00a2aca', 'ba81aa2259e3450d9391c2a2d0351216', '5c8d88dbd44744db8e8eca93f693196d', '3297495c0a77433c8813242fba2dff42', 'b5043ef64485467dbf8bf2a1df12e741', '06613dfe7f3bd58901a3381c826da6b2'];
      this.model['ynkIpeoc7icFAI0yB9gzKJ8DTRfcpAnx'] = calculateTotal(expenses);

      // tslint:disable-next-line:max-line-length
      const income = ['cfb9f6ebddd642caa25302a55d9af66d', '2f774c78153e4c33a07f47cfa6af7e53', 'dec363cac1094e8fa5aa5ec57c271757', '4957f6e41eae4101af8e58beea4c9b04', '18bab7cb4762454a894e532e0a405613', 'dab169e2d50544998957e4950f5341a2', '180c0e8425a84369b322650790d6d5fc', '24c5b5066ca1495aa4dba20e0525fd3c', '237d06862f0e49e8993bf6fab7868afc', '874da3ac12964e6fbda8be34426f5675', '84aac2efddc14bc68a068c042314a332', '8b2c9d16559a4a4f897940ec4ce27eb5', 'cc71d6bb28d74daba17c12cefe92cb65', '5fae3bdbb91d4183ab1495fa56e42091', '64729fa70d7849e89366465af072751f', '86f5aede4941461bbe0f60340044b5d9', 'aadeae8726214f4393bb16280b93536c', '29cf3882ffbc47b8b2398a2a6a953c4a', 'fd1680a05adc43cf9905ecb99f093d0b', '469e087ee8f54d85bd8983700527ad91', 'c60d344dbebb4126bf4376157bdd9647', 'ceddabac07c948d5abdd126aced17cab', '0aa4db0e76f542778ef73c2b7ad76fa0', '5a52df1e3b8e4daabeaa622ac5c0c55c', '16055e9826164b26a0115d5c027ab918'];
      this.model['nPzLw5YdLqFlrxLRmEsC31UkPihkPA0D'] = calculateTotal(income);
    }
  }

  private map(key, answer): any {
    const result = {identification: key};
    if (this.isMultipleChoiceQuestion(key)) {
      result['value'] = '';
      result['type'] = 'simple';
      Object.keys(answer).forEach(subKey => {
        if (answer[subKey]) {
          result['value'] += ' ' + [subKey];
        }
      });
    } else if (answer instanceof Array) {
      result['answers'] = [];
      for (const row of answer) {
        if (JSON.stringify(row) !== '{}') {
          const newRowEntry = [];
          Object.keys(row).forEach(rowKey => {
            const newRowColEntry = {};
            newRowColEntry['value'] = row[rowKey];
            newRowColEntry['identification'] = rowKey;
            newRowColEntry['type'] = 'simple';
            newRowEntry.push(newRowColEntry);
          });
          result['answers'].push(newRowEntry);
        }
      }
      result['type'] = 'complex';
    } else if (answer instanceof Object) {
      result['value'] = answer['value'];
      result['period'] = answer['period'];
      result['type'] = 'period';
    } else {
      result['value'] = answer;
      result['type'] = 'simple';
    }
    return result;
  }

  private mapAnswersToModel(answers) {
    for (const answer of answers) {
      if (answer.type  === 'complex') {
        this.model[answer.identification] = [];
        for (const answerRow of answer.answers) {
          const row = {};
          for (const answerField of answerRow) {
            row[answerField.identification] = answerField.value;
          }
          this.model[answer.identification].push(row);
        }
      } else if (answer.type === 'period') {
        this.model[answer.identification] = { value: answer.value, period: answer.period };
      } else if (answer.type === 'simple') {
        if (this.isMultipleChoiceQuestion(answer.identification)) {
          this.model[answer.identification] = {};
          for (const choice of answer.value.split(' ')) {
            this.model[answer.identification][choice] = true;
          }
        } else {
          this.model[answer.identification] = answer.value;
        }
      }
    }
    this.calculateTotals();
  }

  private isMultipleChoiceQuestion = identification => identification === 'lrtdq5p29iwuhb1zgsc3dye56n78fxk0';

  setCurrentCategory(category) {
    this.currentCategory = category;
    return true;
  }

  concept() {
    if (this.isSaving() || this.isPending()) return;
    if (!this.reportMetaData.requiresPayment || this.userService.isAdmin()) {
      this.showPreviewModal();
    } else {
      this.doYouWantToPay();
    }
  }

  private showPreviewModal() {
    const data = {clientId: this.clientId, type: this.reportTypeCode, year: this.year};
    this.dialog.open(ReportPreviewDialogComponent, {height: '90vh', width: '1300px', data: data});
  }

  finish() {
    if (this.form.invalid) return;
    this.showErrors = true;
    if (this.isSaving() || this.isPending()) return;
    this.service.canFinish(this.clientId, this.reportTypeCode, this.year)
      .subscribe(() => this.handleCanFinish(), response => this.handleCannotFinish(response));
  }

  private handleCanFinish() {
    if (!this.reportMetaData.requiresPayment)
      this.showFinishModal();
     else
      this.doYouWantToPay();
  }

  private handleCannotFinish(response) {
    const error = response.error.message;
    const toImport = () => this.router.navigate([`/bewind/${this.clientId}/importeren`]);
    if (error.startsWith('ACCOUNTS_WITHOUT_TRANSACTIONS')) {
      const text = {
        header: 'er ontbreken transacties',
        body: this.getMissingTransactionMessage(error),
        ok: 'banktransacties inlezen'};
      this.notificationService.inform(text).then(toImport);
    } else if (error === 'NO_ACCOUNTS_PRESENT') {
      console.log(this.year);
      const data = {
        header: 'lees eerst transacties in over het rapportagejaar ' + (this.year ?? ''),
        ok: 'banktransacties inlezen'
      };
      this.notificationService.inform(data).then(toImport);
    } else {
      this.notificationService.errorResponse(response);
    }
  }

  private getMissingTransactionMessage(error) {
    return'de volgende rekeningen bevatten geen transacties over het rapportagejaar ' + (this.year ?? '') +
      '<ul><li>' + error.split('-')[1].split(',').join('</li><li>') + '</li></ul><br>' +
      'heeft u geen toegang meer tot deze rekening? neem dan contact op via de chat rechtsonder of door te mailen naar <a class="link" href="mailto:info@reveon.nl">info@reveon.nl</a>.';
  }

  private showFinishModal() {
    const data = {clientId: this.clientId, type: this.reportTypeCode, year: this.year, downloadFinal: () => this.download(true)};
    this.dialog.open(ConfirmDownloadFinalDialogComponent, {data: data});
  }

  doYouWantToPay() {
    this.notificationService.confirm(this.requiresPayment)
      .then(() => this.router.navigate([`/selecteer-betaalmethode/${this.clientId}/${this.reportMetaData.id}`]));
  }

  download(final) {
    return new Promise<void>(accept => {
      const observable = final ?
        this.service.finish(this.reportTypeCode, this.clientId, this.year) :
        this.service.generate(this.reportTypeCode, this.clientId, this.year);
      this.loaderService.start();
      observable.subscribe((data) => {
        this.loaderService.stop();
        saveAs(data, this.service.reportFileNameOf(this.reportTypeCode, this.year, final));
        this.notificationService.success('rapport gedownload');
        accept();
      });
    });
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean | Observable<boolean> {
    return this.isSaved();
  }

  @HostListener('window:scroll', ['$event']) onWindowScroll(e) {
    const pos = e.target['scrollingElement'].scrollTop;
    if (pos > this.stickyButtonsThreshold && !this.stickyButtons) {
      this.stickyButtons = true;
    } else if (pos < this.stickyButtonsThreshold && this.stickyButtons) {
      this.stickyButtons = false;
    }
  }

  /**
   * for validation purpose and future proofing
   *
   * an accidental next-report-year creation and finish will be prevented
   */
  showFinalButton() {
    const currentYear = new Date().getFullYear();
    switch (this.reportTypeCode) {
      case 'VJE':
        return currentYear >= this.year;
      case 'RV':
        return currentYear > this.year;
      default:
        return true;
    }
  }

  saveAnswer(id: string) {
    this.updateState(id, States.SAVING);
    const answer = this.map(id, this.model[id]);
    this.service.save(this.clientId, this.reportTypeCode, this.year, answer).subscribe(() => this.updateState(id));
  }

  unsaved(id: string) {
    this.updateState(id, States.PENDING);
  }

  isPending() {
    return States.PENDING === this.state;
  }

  isSaving() {
    return States.SAVING === this.state;
  }

  isSaved() {
    return States.SAVED === this.state;
  }

  private updateState(id, value?) {
    if (value !== undefined) {
      this.subscriptions.set(id, value);
    } else {
      this.subscriptions.delete(id);
    }

    const subscriptions = [];
    this.subscriptions.forEach(state => subscriptions.push(state));
    const pending = subscriptions.filter(s => s === States.PENDING).length;
    const saving = subscriptions.filter(s => s === States.SAVING).length;

    if (pending === 0 && saving === 0) {
      this.state = States.SAVED;
    } else if (pending > 0 && saving === 0) {
      this.state = States.PENDING;
    } else if (saving > 0) {
      this.state = States.SAVING;
    }
  }
}
